import { useEffect, useRef, useState } from 'react'
import { IconosPlan } from './IconosPlantilla'
import { abonoIds, cargoIds, ajusteIds } from './plantillasCategorias'
import { getPlantillasBanco } from './plantillasCategorias'
import SelectorVinculacionBanco from './SelectorVinculacionBanco'
import ModalVinculacionGenerica from './modalDialogVinculacionGenerica/ModalVinculacionGenerica'
import RetiroDividendo from './Modales/RetiroDividendo'
import PagoArriendos from './Modales/PagoArriendos'
import CobroArriendos from './Modales/CobroArriendos'
import GastosComunes from './Modales/GastosComunes'
import PrestamoOtorgado from './Modales/Prestamo//PrestamoOtorgado'
import PrestamoRecibido from './Modales/Prestamo/PrestamoRecibido'
import DevolucionImpuestos from './Modales/DevolucionImpuestos'
import AporteTransitorioSocio from './Modales/AporteTransitorioSocio'
import PagoPatenteComercial from './Modales/PagoPatenteComercial'
import PagoContribuciones from './Modales/PagoContribuciones'
import AddIcon from '@mui/icons-material/Add';
import { Title } from '../../../../ui'
import Tarjetas from './Modales/Tarjetas'
import CobroCuotaPrestamo from './Modales/CobroCuotaPrestamo'
import PagoCuotaPrestamo from './Modales/PagoCuotaPrestamo'
import DevolucionAporteTransitorio from './Modales/DevolucionAporteTransitorio'
import RendicionDeGastos from './Modales/RendicionDeGastos'
import Invoice from './Modales/InvoiceCompra'
import InvoiceImportaciones from './Modales/InvoiceImportaciones'
import GenericoCargo from './Modales/GenericoCargo'
import GenericaAbono from './Modales/GenericaAbono'
import CobroCajaPrincipal from './Modales/CajaPrincipal/CobroCajaPrincipal'
import PagoCajaPrincipal from './Modales/CajaPrincipal/PagoCajaPrincipal'
import QuestionIcon from '@mui/icons-material/HelpOutline'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles'
import InvoiceVenta from './Modales/InvoiceVenta'
import Finiquitos from './Modales/Finiquitos'
import ValoresNegociables from './Modales/ValoresNegociables'
import Inversiones from './Modales/Inversiones'
import AjusteExistencias from './Modales/AjusteExistencias'
import AnticipoAgenteAduana from './Modales/AnticipoAgenteAduana'
import DevolucionAgenteAduana from './Modales/DevolucionAgenteAduana'
import AnticipoSueldo from './Modales/AnticipoSueldo'
import ProvisionAgenteAduana from './Modales/ProvisionAgenteAduana'
import Multas from './Modales/Multas'
import {
  AporteEmpresaRelacionada,
  DevolucionEmpresaRelacionada
} from './Modales/EmpresaRelacionada'
import CuentaCorrienteEmpresaRelacionada from './Modales/CuentaCorrienteEmpresaRelacionada'
import { sileo } from 'sileo'

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#000033',
    color: '#fff',
    fontSize: '0.75rem',
    padding: '6px 12px',
    borderRadius: '6px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#000033',
  },
}));

const Plantillas = ({
  setSwitchGetData,
  tipoMovimientoBanco,
  hideCreationModals = false,
  onMassivePeriodTrace,
  dinRevTemplateState = { status: 'loading', documents: [], responseData: null }
}) => {
  const [openModal, setOpenModal] = useState(false)
  const [openModalArriendo, setOpenModalArriendo] = useState(false)
  const [openModalCobro, setOpenModalCobro] = useState(false)
  const [openModalGastos, setOpenModalGastos] = useState(false)
  const [openRetiro, setOpenRetiro] = useState(false)
  const [openPresOto, setOpenPresOto] = useState(false)
  const [openPresRec, setOpenPresRec] = useState(false)
  const [openDevolucionImpuestos, setOpenDevolucionImpuestos] = useState(false)
  const [openAporte, setOpenAporte] = useState(false)
  const [openPagoPat, setOpenPagoPat] = useState(false)
  const [openPagoCont, setOpenPagoCont] = useState(false)
  const [openModalOtrasCobro, setOpenModalOtrasCobro] = useState(false);
  const [openModalOtrasPago, setOpenModalOtrasPago] = useState(false);
  const [openModalOtrasAjuste, setOpenModalOtrasAjuste] = useState(false);
  const [openCobroCuota, setOpenCobroCuota] = useState(false)
  const [openPagoCuota, setOpenPagoCuota] = useState(false)
  const [openDevolucion, setOpenDevolucion] = useState(false)
  const [openRendiciion, setOpenRendicion] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [openInvoiceImportaciones, setOpenInvoiceImportaciones] = useState(false)
  const [openGenericoCargo, setOpenGenericoCargo] = useState(false)
  const [openGenericaAbono, setOpenGenericaAbono] = useState(false)
  const [openInvoiceV, setOpenInvoiceV] = useState(false)
  const [openCCajaP, setOpenCCajaP] = useState(false)
  const [openPCajaP, setOpenPCajaP] = useState(false)
  const [openFiniquito, setOpenFiniquito] = useState(false)
  const [openInversiones, setOpenInversiones] = useState(false)
  const [openNegociable, setOpenNegociables] = useState(false)
  const [openAjuste, setOpenAjuste] = useState(false)
  const [openAnticipoAgenteAduana, setOpenAnticipoAgenteAduana] = useState(false)
  const [openDevolucionAgenteAduana, setOpenDevolucionAgenteAduana] = useState(false)
  const [openAnticipoSueldo, setOpenAnticipoSueldo] = useState(false)
  const [openProvisionAgenteAduana, setOpenProvisionAgenteAduana] = useState(false)
  const [provisionAgenteAduanaAction, setProvisionAgenteAduanaAction] = useState('crear')
  const [openMultas, setOpenMultas] = useState(false)
  const [openAporteEmpresaRelacionada, setOpenAporteEmpresaRelacionada] = useState(false)
  const [openDevolucionEmpresaRelacionada, setOpenDevolucionEmpresaRelacionada] = useState(false)
  const [openCuentaCorrienteEmpresaRelacionada, setOpenCuentaCorrienteEmpresaRelacionada] = useState(false)
  const contenedorRefCobro = useRef(null)
  const contenedorRefPago = useRef(null)
  const contenedorRefAjuste = useRef(null)
  const [maxVisibleCobro, setMaxVisibleCobro] = useState(3)
  const [maxVisiblePago, setMaxVisiblePago] = useState(3)
  const [maxVisibleAjuste, setMaxVisibleAjuste] = useState(3)

  const modalHandlers = {
  '3': setOpenModalGastos,
  '5': setOpenModalArriendo,
  '6': setOpenModalCobro,
  '7': setOpenRetiro,
  '8': setOpenPresOto,
  '9': setOpenPresRec,
  '10': setOpenAporte,
  '11': setOpenPagoPat,
  '12': setOpenPagoCont,
  '14': setOpenCobroCuota,
  '15': setOpenPagoCuota,
  '16': setOpenDevolucion,
  '17': setOpenRendicion,
  '18': setOpenInvoice,
  '38': setOpenInvoiceImportaciones,
  '28': setOpenAnticipoAgenteAduana,
  '34': setOpenDevolucionAgenteAduana,
  '29': setOpenAnticipoSueldo,
  '32': setOpenProvisionAgenteAduana,
  '33': setOpenMultas,
  '35': setOpenAporteEmpresaRelacionada,
  '36': setOpenDevolucionEmpresaRelacionada,
  '37': setOpenCuentaCorrienteEmpresaRelacionada,
  '30': setOpenGenericoCargo,
  '31': setOpenGenericaAbono,
  '19': setOpenCCajaP,
  '20': setOpenPCajaP,
  '21': setOpenInvoiceV,
  '22': setOpenFiniquito,
  '23': setOpenInversiones,
  '24': setOpenNegociables,
  '25': setOpenAjuste,
  '39': setOpenDevolucionImpuestos,
};

const handleIconClick = (id) => {
  if (id === '32') {
    if (dinRevTemplateState.status === 'loading') {
      sileo.info({
        title: 'Consultando movimientos',
        description: 'Espera un momento mientras revisamos la cuenta corriente del agente de aduana.'
      })
      return
    }

    if (dinRevTemplateState.status === 'error') {
      sileo.error({
        title: 'No se pudo consultar la cuenta corriente',
        description: 'Intenta nuevamente antes de crear o editar movimientos.'
      })
      return
    }

    setProvisionAgenteAduanaAction(
      dinRevTemplateState.status === 'existing' ? 'editar' : 'crear'
    )
    setOpenProvisionAgenteAduana(true)
    return
  }

  const openModalFunc = modalHandlers[id];
  if (openModalFunc) openModalFunc(true);
};

  const cobroIds = abonoIds
  const pagoIds = cargoIds

  useEffect(() => {
  const CARD_WIDTH = 112        // ancho real de la card + gap
  const MIN_VISIBLE = 2         // 2 tarjetas + "Otras"
  const MIN_CONTAINER_WIDTH = 380 // desktop pequeño (NO mobile)

  const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      const ancho = entry.contentRect.width
      const caben = Math.floor(ancho / CARD_WIDTH)

      // regla final
      const visiblesFinal =
        ancho < MIN_CONTAINER_WIDTH
          ? MIN_VISIBLE
          : Math.max(MIN_VISIBLE, caben - 1)

      if (entry.target === contenedorRefCobro.current) {
        setMaxVisibleCobro(visiblesFinal)
      }

      if (entry.target === contenedorRefPago.current) {
        setMaxVisiblePago(visiblesFinal)
      }

      if (entry.target === contenedorRefAjuste.current) {
        setMaxVisibleAjuste(visiblesFinal)
      }
    }
  })

  if (contenedorRefCobro.current) observer.observe(contenedorRefCobro.current)
  if (contenedorRefPago.current) observer.observe(contenedorRefPago.current)
  if (contenedorRefAjuste.current) observer.observe(contenedorRefAjuste.current)

  return () => observer.disconnect()
}, [])


  const cobroItems = IconosPlan.filter((item) => cobroIds.includes(item.id))
  const visiblesCobro = cobroItems.slice(0, maxVisibleCobro)

  // Pago
  const pagoItems = IconosPlan.filter((item) => pagoIds.includes(item.id))
  const visiblesPago = pagoItems.slice(0, maxVisiblePago)

  const ajusteItems = IconosPlan.filter((item) => ajusteIds.includes(item.id))
  const visiblesAjuste = ajusteItems.slice(0, maxVisibleAjuste)

  const renderTemplate = (template) => {
    return (
      <div
        key={template.id}
        className="relative flex flex-col items-center justify-center shadow-md border rounded-xl p-2 cursor-pointer w-24 h-24 md:w-21 md:h-21"
        onClick={() => {
          if (template.id === '13a') {
            setOpenModalOtrasCobro(true);
          } else if (template.id === '13b') {
            setOpenModalOtrasPago(true);
          } else if (template.id === '13c') {
            setOpenModalOtrasAjuste(true);
          } else {
            handleIconClick(template.id);
          }
        }}
      >
        {/* Mostrar tooltip solo si NO es 13a o 13b */}
        {template.id !== '13a' && template.id !== '13b' && template.id !== '13c' && (
          <div
            className="absolute top-0 right-1"
            onClick={(e) => e.stopPropagation()} // evita disparar click de la tarjeta
          >
            <CustomTooltip title={template.tooltipText || "Sin descripción"} arrow>
              <QuestionIcon
                fontSize="inherit"
                className="text-gray-400 hover:text-gray-500 cursor-pointer"
                style={{ fontSize: '16px' }} // más pequeño
              />
            </CustomTooltip>
          </div>
        )}

        {/* Icono principal */}
        <template.icon className="w-12 h-12 md:w-12 md:h-12 mb-1" />

        {/* Título */}
        <h3 className="text-[9px] font-semibold font-sans text-center leading-tight">
          {template.title}
        </h3>
      </div>
    )
  }
  
  return (
    <>
      {tipoMovimientoBanco ? (
        <SelectorVinculacionBanco
          items={getPlantillasBanco(IconosPlan, tipoMovimientoBanco)}
          onSelect={handleIconClick}
        />
      ) : (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full min-w-0">
        {/* COBRO */}
        <div className="flex flex-col w-full min-w-0">
          <Title className='text-lg'>Vinculación de Abono</Title>
          <div ref={contenedorRefCobro} className="rounded-3xl bg-gray-50 flex gap-2 p-4 border overflow-hidden flex-nowrap" >
            {visiblesCobro.map(renderTemplate)}
            {renderTemplate({ icon: AddIcon, title: 'Otras', id: '13a' })}
          </div>
        </div>

        {/* AJUSTE */}
        <div className="flex flex-col w-full min-w-0">
          <Title className='text-lg'>Vinculación de Ajuste</Title>
          <div ref={contenedorRefAjuste} className="rounded-3xl bg-gray-50 flex gap-2 p-4 border overflow-hidden flex-nowrap" >
            {visiblesAjuste.map(renderTemplate)}
            {renderTemplate({ icon: AddIcon, title: 'Otras', id: '13c' })}
          </div>
        </div>

        {/* PAGO */}
        <div className="flex flex-col w-full min-w-0">
          <Title className='text-lg'>Vinculación de Cargo</Title>
          <div ref={contenedorRefPago} className="rounded-3xl bg-gray-50 flex gap-2 p-4 border overflow-hidden flex-nowrap" >
            {visiblesPago.map(renderTemplate)}
            {renderTemplate({ icon: AddIcon, title: 'Otras', id: '13b' })}
          </div>
        </div>

      </div>
      )}
      {openModal && (
          <ModalVinculacionGenerica 
              open={openModal && !hideCreationModals}
              setOpen={setOpenModal}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openModalArriendo && (
          <PagoArriendos
              open={openModalArriendo && !hideCreationModals}
              setOpen={setOpenModalArriendo}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openModalCobro && (
          <CobroArriendos
              open={openModalCobro && !hideCreationModals}
              setOpen={setOpenModalCobro}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openModalGastos && (
          <GastosComunes
              open={openModalGastos && !hideCreationModals}
              setOpen={setOpenModalGastos}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openRetiro && (
          <RetiroDividendo
              open={openRetiro && !hideCreationModals}
              setOpen={setOpenRetiro}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openPresOto && (
          <PrestamoOtorgado
              open={openPresOto && !hideCreationModals}
              setOpen={setOpenPresOto}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openPresRec && (
          <PrestamoRecibido
              open={openPresRec && !hideCreationModals}
              setOpen={setOpenPresRec}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openDevolucionImpuestos && (
        <DevolucionImpuestos
          open={openDevolucionImpuestos && !hideCreationModals}
          setOpen={setOpenDevolucionImpuestos}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openAporte && (
          <AporteTransitorioSocio
              open={openAporte && !hideCreationModals}
              setOpen={setOpenAporte}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openPagoPat && (
          <PagoPatenteComercial
              open={openPagoPat && !hideCreationModals}
              setOpen={setOpenPagoPat}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openPagoCont && (
          <PagoContribuciones
              open={openPagoCont && !hideCreationModals}
              setOpen={setOpenPagoCont}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openCobroCuota && (
          <CobroCuotaPrestamo
              open={openCobroCuota && !hideCreationModals}
              setOpen={setOpenCobroCuota}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openPagoCuota && (
          <PagoCuotaPrestamo
              open={openPagoCuota && !hideCreationModals}
              setOpen={setOpenPagoCuota}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openDevolucion && (
          <DevolucionAporteTransitorio
              open={openDevolucion && !hideCreationModals}
              setOpen={setOpenDevolucion}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openRendiciion && (
          <RendicionDeGastos
              open={openRendiciion && !hideCreationModals}
              setOpen={setOpenRendicion}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openInvoice && (
          <Invoice
              open={openInvoice && !hideCreationModals}
              setOpen={setOpenInvoice}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
          />
      )}
      {openInvoiceImportaciones && (
        <InvoiceImportaciones
          open={openInvoiceImportaciones && !hideCreationModals}
          setOpen={setOpenInvoiceImportaciones}
          setSwitchDate={setSwitchGetData}
        />
      )}
      {openGenericoCargo && (
        <GenericoCargo
          open={openGenericoCargo && !hideCreationModals}
          setOpen={setOpenGenericoCargo}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openGenericaAbono && (
        <GenericaAbono
          open={openGenericaAbono && !hideCreationModals}
          setOpen={setOpenGenericaAbono}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openAnticipoAgenteAduana && (
        <AnticipoAgenteAduana
          open={openAnticipoAgenteAduana && !hideCreationModals}
          setOpen={setOpenAnticipoAgenteAduana}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openDevolucionAgenteAduana && (
        <DevolucionAgenteAduana
          open={openDevolucionAgenteAduana && !hideCreationModals}
          setOpen={setOpenDevolucionAgenteAduana}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openAnticipoSueldo && (
        <AnticipoSueldo
          open={openAnticipoSueldo && !hideCreationModals}
          setOpen={setOpenAnticipoSueldo}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openProvisionAgenteAduana && (
        <ProvisionAgenteAduana
          open={openProvisionAgenteAduana && !hideCreationModals}
          setOpen={setOpenProvisionAgenteAduana}
          setSwitchDate={setSwitchGetData}
          action={provisionAgenteAduanaAction}
          provisionMode={
            provisionAgenteAduanaAction === 'editar' ? 'conciliar-din-rev' : 'registro'
          }
          dinRevData={dinRevTemplateState.responseData}
          dinRevDocuments={dinRevTemplateState.documents}
        />
      )}
      {openMultas && (
        <Multas
          open={openMultas && !hideCreationModals}
          setOpen={setOpenMultas}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openAporteEmpresaRelacionada && (
        <AporteEmpresaRelacionada
          open={openAporteEmpresaRelacionada && !hideCreationModals}
          setOpen={setOpenAporteEmpresaRelacionada}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openDevolucionEmpresaRelacionada && (
        <DevolucionEmpresaRelacionada
          open={openDevolucionEmpresaRelacionada && !hideCreationModals}
          setOpen={setOpenDevolucionEmpresaRelacionada}
          setSwitchDate={setSwitchGetData}
          action='crear'
        />
      )}
      {openCuentaCorrienteEmpresaRelacionada && (
        <CuentaCorrienteEmpresaRelacionada
          open={openCuentaCorrienteEmpresaRelacionada && !hideCreationModals}
          setOpen={setOpenCuentaCorrienteEmpresaRelacionada}
        />
      )}
      {openCCajaP && (
          <CobroCajaPrincipal
              open={openCCajaP && !hideCreationModals}
              setOpen={setOpenCCajaP}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
              onMassivePeriodTrace={onMassivePeriodTrace}
          />
      )}
      {openPCajaP && (
          <PagoCajaPrincipal
              open={openPCajaP && !hideCreationModals}
              setOpen={setOpenPCajaP}
              setSwitchDate={setSwitchGetData}
              action={'crear'}
              onMassivePeriodTrace={onMassivePeriodTrace}
          />
      )}
      {openInvoiceV && (
        <InvoiceVenta 
          open={openInvoiceV && !hideCreationModals}
          setOpen={setOpenInvoiceV}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openFiniquito && (
        <Finiquitos 
          open={openFiniquito && !hideCreationModals}
          setOpen={setOpenFiniquito}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openInversiones && (
        <Inversiones
          open={openInversiones && !hideCreationModals}
          setOpen={setOpenInversiones}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openNegociable && (
        <ValoresNegociables
          open={openNegociable && !hideCreationModals}
          setOpen={setOpenNegociables}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
      {openAjuste && (
        <AjusteExistencias
          open={openAjuste && !hideCreationModals}
          setOpen={setOpenAjuste}
          setSwitchDate={setSwitchGetData}
          action={'crear'}
        />
      )}
    {openModalOtrasCobro && (
      <Tarjetas
        open={openModalOtrasCobro && !hideCreationModals}
        setOpen={setOpenModalOtrasCobro}
        title="Otras vinculaciones de cobro"
        items={cobroItems}
        onCardClick={(id) => handleIconClick(id)}
      />
    )}

    {openModalOtrasPago && (
      <Tarjetas
        open={openModalOtrasPago && !hideCreationModals}
        setOpen={setOpenModalOtrasPago}
        title="Otras vinculaciones de pago"
        items={pagoItems}
        onCardClick={(id) => handleIconClick(id)}
      />
    )}

    {openModalOtrasAjuste && (
      <Tarjetas
        open={openModalOtrasAjuste && !hideCreationModals}
        setOpen={setOpenModalOtrasAjuste}
        title="Otras vinculaciones de ajuste"
        items={ajusteItems}
        onCardClick={(id) => handleIconClick(id)}
      />
    )}
    </>
  )
}

export default Plantillas
